module.exports = __webpack_public_path__ + "img/t4-9.409becfa.svg";